import script from "./GameImage.vue?vue&type=script&setup=true&lang=js"
export * from "./GameImage.vue?vue&type=script&setup=true&lang=js"

import "./GameImage.vue?vue&type=style&index=0&id=1b5e83b1&scoped=true&lang=css"
import "./GameImage.vue?vue&type=style&index=1&id=1b5e83b1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b5e83b1"]])

export default __exports__